import { yupResolver } from "@hookform/resolvers/yup";
import { useCallback, useEffect, useState } from "react";
import { FormProvider, useForm } from "react-hook-form";
import { MarketRegisterLayout } from "~/components/common/layouts/MarketRegisterLayout";
import { FormCompletePage } from "~/components/specifics/markets/company_settings/new/FormCompletePage";
import { FormConfirmPage } from "~/components/specifics/markets/company_settings/new/FormConfirmPage";
import { FormInputPage } from "~/components/specifics/markets/company_settings/new/FormInputPage";
import type { IndicatorItem } from "~/components/specifics/markets/company_settings/new/progress_indicator/ProgressIndicator";
import { ProgressIndicator } from "~/components/specifics/markets/company_settings/new/progress_indicator/ProgressIndicator";
import { useCompanySettings } from "~/hooks/markets/useCompanySettings";
import type { MarketCompanySetting } from "~/models/CompanySetting";
import { validationSchemaMarketCompanySetting } from "~/models/CompanySetting";
import Styles from "./Page.module.scss";

const indicatorItems: IndicatorItem[] = [
	{ label: "登録情報の入力" },
	{ label: "内容確認" },
	{ label: "完了" }
];

const INPUT_PAGE_NUMBER = 0;
const CONFIRM_PAGE_NUMBER = 1;
const COMPLETE_PAGE_NUMBER = 2;

export function Page() {
	const { data: initialCompanySetting } = useCompanySettings().show();
	const [pageNumber, setPageNumber] = useState(INPUT_PAGE_NUMBER);
	const methods = useForm<MarketCompanySetting>({
		mode: "onBlur",
		resolver: yupResolver(validationSchemaMarketCompanySetting)
	});
	const handleNextPage = useCallback(() => {
		setPageNumber((prevPageNumber) => prevPageNumber + 1);
	}, []);
	const handlePrevPage = useCallback(() => {
		setPageNumber((prevPageNumber) => prevPageNumber - 1);
	}, []);
	useEffect(() => {
		if (initialCompanySetting === null || initialCompanySetting.existSetting) {
			return;
		}
		const {
			companyName,
			ceoLastName,
			ceoFirstName,
			managedUnitNumber,
			phoneNumber,
			zipcode,
			state,
			email
		} = initialCompanySetting;
		methods.reset((prevValues) => ({
			...prevValues,
			ceoFirstName,
			ceoLastName,
			companyName,
			email,
			managedUnitNumber,
			phoneNumber,
			state,
			zipcode
		}));
	}, [methods, initialCompanySetting]);
	if (initialCompanySetting === null) {
		return null;
	}
	// 既に登録済みの場合は入力・確認を飛ばして完了ページを表示する
	const currentPageNumber = initialCompanySetting.existSetting
		? COMPLETE_PAGE_NUMBER
		: pageNumber;
	return (
		<MarketRegisterLayout>
			<div className={Styles.Container}>
				<h1 className={Styles.Title}>修繕おまかせサービス 利用開始</h1>
				<div className={Styles.Indicator}>
					<div className={Styles.IndicatorWrapper}>
						<ProgressIndicator
							currentIndex={currentPageNumber}
							items={indicatorItems}
						/>
					</div>
				</div>
				<FormProvider {...methods}>
					{currentPageNumber === INPUT_PAGE_NUMBER && (
						<FormInputPage handleNextPage={handleNextPage} />
					)}
					{currentPageNumber === CONFIRM_PAGE_NUMBER && (
						<FormConfirmPage
							handleNextPage={handleNextPage}
							handlePrevPage={handlePrevPage}
						/>
					)}
					{currentPageNumber === COMPLETE_PAGE_NUMBER && <FormCompletePage />}
				</FormProvider>
			</div>
		</MarketRegisterLayout>
	);
}
